const DARK = '000000';
const LIGHT = 'FFFFFF';

function getContrastYIQ(hex) {
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return (yiq >= 128) ? DARK : LIGHT;
}

function stripHash(color) {
  return color?.[0] === '#' ? color.slice(1) : color;
}

export default {
  mounted(el, binding) {
    const color = stripHash(binding.value);
    el.style.backgroundColor = `#${color}`;
    el.style.color = `#${getContrastYIQ(color)}`;
  },
  updated(el, binding) {
    const color = stripHash(binding.value);
    el.style.backgroundColor = `#${color}`;
    el.style.color = `#${getContrastYIQ(color)}`;
  },
};
